import GuestlistCreateModalController from '../../../../modules/guestlists/controllers/modals/create-modal-controller';
import GuestlistAfterCreateModalController
    from '../../../../modules/guestlists/controllers/modals/after-create-modal-controller';
import createModalTemplate from '../../../../modules/guestlists/views/modals/create-modal.tpl.html';
import afterCreateModalTemplate from '../../../../modules/guestlists/views/modals/after-create-modal.tpl.html';

class createGuestlist {
    constructor($injector) {
        this.key = 'create-guestlist';
        this.title = 'Create a new guestlist';
        this.level = 'highlight';
        this.icon = 'plus-circle';
        this.order = 10;
        this.state = $injector.get('$state');
        this.uibModal = $injector.get('$uibModal');
        this.alert = $injector.get('Alert');
        this.translate = $injector.get('$translate');
        this.navHelper = $injector.get('NavHelper');
    }

    action({}, store) {
        return this.uibModal.open({
            controller: GuestlistCreateModalController,
            keyboard: false,
            backdrop: 'static',
            controllerAs: 'vm',
            templateUrl: createModalTemplate
        }).result.then((data) => {
            const guestlistData = data.guestlist;

            this.alert.success(this.translate.instant('guestlists.workflows.create-guestlist.messages.created.title'), this.translate.instant('guestlists.workflows.create-guestlist.messages.created.message'));
            this.navHelper.updateEventInformation();
            this.state.go('app.guestlists.rsvps.index', {gid: guestlistData.id});

            return this.uibModal.open({
                controller: GuestlistAfterCreateModalController,
                controllerAs: 'vm',
                templateUrl: afterCreateModalTemplate,
                resolve: {
                    guestlist: () => {
                        return guestlistData;
                    }
                }
            }).result.then(() => {

            }, () => {

            });
        }, () => {
            console.log('modal closed');
        });
        // return this.state.go('app.guestlists.create', {store: store, backParams: {store: store}});
    }

}

angular
    .module('festzelt-os.guestlists')
    .factory('createGuestlist', [
        '$injector',
        ($injector) => new createGuestlist($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/workflows/general/create-guestlist.js